module.exports = new __parcel__URL__("customCursor.8a87402c.svg").toString();